$(document).ready(function () {
  const $items = $('.accordion-section .item .content');

  $items.each(function (index) {
    const $item = $(this);

    const trigger = ScrollTrigger.create({
      trigger: $item,
      start: "top top",
      end: "bottom top",
      markers: false,

      onEnter: () => {
        $('.accordion-section .item').removeClass('active');
        $items.eq(index).addClass('active').parent().addClass('active');
      },

      onLeaveBack: () => {
        if (index > 0) {
          $('.accordion-section .item').removeClass('active');
          $items.eq(index - 1).addClass('active').parent().addClass('active');
        }
      },

      onUpdate: (self) => {
        const progress = (self.progress - 0.6) / 0.2;

        if (self.progress >= 0.6 && self.progress <= 0.8) {
          $item.css('opacity', 1 - progress);
        } else if (self.progress < 0.6) {
          $item.css('opacity', 1);
        } else if (self.progress > 0.8) {
          $item.css('opacity', 0);
        }
      }
    });

    // ✅ Run immediately to ensure proper state when loading at scroll position
    ScrollTrigger.refresh(true);
  });
});
